import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { properties, plants } from '../services/api';
import axios from 'axios';
import GardenModal from './GardenModal';
import { useIsMobile } from '../hooks/useIsMobile';
import './EditTask.css';

const API = process.env.REACT_APP_API_URL;

function EditTask() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState({ isOpen: false });
  const [userProperties, setUserProperties] = useState([]);
  const [userPlants, setUserPlants] = useState([]);
  const [formData, setFormData] = useState({
    propertyId: '',
    plantId: '',
    taskType: 'custom',
    title: '',
    description: '',
    scheduledFor: '',
    recurrence: 'none'
  });


  useEffect(() => {
    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadData = async () => {
    try {
      const token = localStorage.getItem('token');
      const [propsRes, plantsRes, taskRes] = await Promise.all([
        properties.getAll(),
        plants.getAll(),
        axios.get(`${API}/tasks/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        })
      ]);
      setUserProperties(propsRes.data.properties);
      setUserPlants(plantsRes.data.plants);
      const task = taskRes.data.task;
      setFormData({
        propertyId: task.property_id || '',
        plantId: task.plant_id || '',
        taskType: task.task_type || 'custom',
        title: task.title || '',
        description: task.description || '',
        scheduledFor: task.scheduled_for?.split('T')[0] || '',
        recurrence: task.recurrence_rule || 'none'
      });
      setLoading(false);
    } catch (error) {
      console.error('EditTask load error:', error);
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${API}/tasks/${id}`, {
        propertyId: formData.propertyId,
        plantId: formData.plantId || null,
        taskType: formData.taskType,
        title: formData.title,
        description: formData.description,
        scheduledFor: formData.scheduledFor,
        recurrenceRule: formData.recurrence !== 'none' ? formData.recurrence : null
      }, { headers: { Authorization: `Bearer ${token}` } });
      setModal({
        isOpen: true, type: 'alert', title: 'Saved',
        message: 'Task updated successfully',
        onConfirm: () => { setModal({ isOpen: false }); navigate('/tasks'); }
      });
    } catch (error) {
      console.error('EditTask save error:', error);
      setModal({
        isOpen: true, type: 'alert', title: 'Error',
        message: 'Failed to update task',
        onConfirm: () => setModal({ isOpen: false })
      });
    }
  };

  if (loading) return <div className="edit-task-loading">Loading...</div>;

  return (
    <div className={`edit-task-container${isMobile ? ' edit-task-container--mobile' : ''}`}>
      <GardenModal isOpen={modal.isOpen} type={modal.type} title={modal.title} message={modal.message} onConfirm={modal.onConfirm} onCancel={() => setModal({ isOpen: false })} />
      <h2>Edit Task</h2>
      <form onSubmit={handleSubmit} className="edit-task-form">
        <div className="edit-task-field">
          <label className="edit-task-label">Property</label>
          <select value={formData.propertyId} onChange={(e) => setFormData({...formData, propertyId: e.target.value})}
            className="edit-task-input">
            {userProperties.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        </div>
        <div className="edit-task-field">
          <label className="edit-task-label">Plant</label>
          <select value={formData.plantId} onChange={(e) => setFormData({...formData, plantId: e.target.value})}
            className="edit-task-input">
            <option value="">All plants / General task</option>
            {userPlants.map(p => <option key={p.id} value={p.id}>{p.common_name}</option>)}
          </select>
        </div>
        <div className="edit-task-field">
          <label className="edit-task-label">Task Type</label>
          <select value={formData.taskType} onChange={(e) => setFormData({...formData, taskType: e.target.value})}
            className="edit-task-input">
            <option value="watering">Watering</option>
            <option value="fertilize">Fertilizing</option>
            <option value="pruning">Pruning</option>
            <option value="pest_control">Pest Control</option>
            <option value="mowing">Mowing</option>
            <option value="weeding">Weeding</option>
            <option value="harvesting">Harvesting</option>
            <option value="custom">Custom</option>
          </select>
        </div>
        <div className="edit-task-field">
          <label className="edit-task-label">Title *</label>
          <input type="text" value={formData.title} onChange={(e) => setFormData({...formData, title: e.target.value})}
            required style={{ width: '100%', padding: '8px', fontSize: '0.875rem', border: '1px solid #ddd', borderRadius: '4px' }} />
        </div>
        <div className="edit-task-field">
          <label className="edit-task-label">Description</label>
          <textarea value={formData.description} onChange={(e) => setFormData({...formData, description: e.target.value})}
            rows="3" className="edit-task-textarea" />
        </div>
        <div className="edit-task-field">
          <label className="edit-task-label">Scheduled For *</label>
          <input type="date" value={formData.scheduledFor} onChange={(e) => setFormData({...formData, scheduledFor: e.target.value})}
            required style={{ width: '100%', padding: '8px', fontSize: '0.875rem', border: '1px solid #ddd', borderRadius: '4px' }} />
        </div>
        <div className="edit-task-field edit-task-field--last">
          <label className="edit-task-label">Repeat</label>
          <select value={formData.recurrence} onChange={(e) => setFormData({...formData, recurrence: e.target.value})}
            className="edit-task-input">
            <option value="none">Does not repeat</option>
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="biweekly">Every 2 weeks</option>
            <option value="monthly">Monthly</option>
          </select>
        </div>
        <div className="edit-task-actions">
          <button type="submit" className="edit-task-btn-save">
            Save Changes
          </button>
          <button type="button" onClick={() => navigate('/tasks')}
            className="edit-task-btn-cancel">
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditTask;
